/* eslint-disable arrow-body-style */
import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import { components, DropdownIndicatorProps } from 'react-select';
import styles from './Select.module.css';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { filterPlantName } from '../../redux/actions/plantsAction';
import { useAuthorizationContext } from '../../providers/AuthorizationHandler/AuthorizationHandler';
import { plant_options } from '../../constants/constVariables';

const defaultOptions = [
    { label: 'pune', value: 'pune' },
    { label: 'Jharkand', value: 'jharkand' },
];

const Select = ({
    label,
    options = defaultOptions,
    selectClassName,
    selectName,
    maxMenuHeight = 160,
    onChange,
    isLoading,
    title,
    ...props
}) => {
    const { user, logoutUser } = useAuthorizationContext();
    const dropdownPlantName = window.localStorage.getItem('PLANT_FILTER_NAME');
    const [currentValue, setCurrentValue] = useState(dropdownPlantName);
    const [count, setcount] = useState(0)
    useEffect(() => {
        if (dropdownPlantName) {
            window.localStorage.setItem('PLANT_FILTER_NAME', dropdownPlantName)
        }
    }, []);
    useEffect(() => {
        if (options[0]) {
            window.localStorage.setItem('PLANT_FILTER_NAME', dropdownPlantName ? dropdownPlantName : JSON.stringify(options[0]))
        }
    }, [options]);
    const DropdownIndicator = (
        props
    ) => {
        return (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-19bqh2r" fill='rgb(204, 204, 204)'>
                    <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                </svg>
            </components.DropdownIndicator>
        );
    };
    return (
        <div {...props}>
            {label}
            <ReactSelect
                isLoading={isLoading}
                options={options}
                defaultValue={title == "dispatchDropdown" || title=="usageAnalyticsDropdown"? options[0] : JSON.parse(currentValue) || options[0]}
                className={clsx(styles.select, selectClassName)}
                classNamePrefix={`select-${selectName}`}
                maxMenuHeight={maxMenuHeight}
                components={{ DropdownIndicator }}
                styles={{
                    menuList: provided => ({
                        ...provided,
                        '&::-webkit-scrollbar': {
                            width: '4px !important',
                            height: '6px',
                            display: 'block !important',
                            background: 'none'
                        },
                        '&::-webkit-scrollbar-track': {
                            background: 'none',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: '#f17c7c',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            background: '#da6363',
                        },
                    }),
                    control: provided => ({
                        ...provided,
                        minHeight: 0,
                        height: '100%',
                        padding: 0,
                        border: '1px solid #608FC9'
                    }),
                    dropdownIndicator: provided => ({
                        ...provided,
                        width: '30px',
                        padding: '0',
                    }),
                    indicatorSeparator: () => null,
                    singleValue: provided => ({
                        ...provided,
                        color: '#2E75B5',
                        fontWeight: 700,
                        fontSize: '14px'
                    }),
                    indicatorsContainer: provided => ({
                        ...provided,
                        color: '#2E75B5',

                    })
                }}
                onChange={(e) => { onChange(e); setcount(0) }}
            />
        </div>
    );
};

Select.propTypes = {
    label: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.any.isRequired,
        }),
    ),
    selectClassName: PropTypes.string,
    selectName: PropTypes.string,
    maxMenuHeight: PropTypes.number,
    onChange: PropTypes.func,
    isLoading: PropTypes.bool,
};

export default Select;
